import { render } from "./ZonesAndProducts.vue?vue&type=template&id=42a8c3b1"
import script from "./ZonesAndProducts.vue?vue&type=script&lang=js"
export * from "./ZonesAndProducts.vue?vue&type=script&lang=js"

import "./ZonesAndProducts.vue?vue&type=style&index=0&id=42a8c3b1&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__